import React, { ReactElement, useEffect } from 'react';
import {
  BackButton,
  Breadcrumbs, getTitle, homeBreadcrumb, NotFoundPage, PageLoader, setTitle,
} from 'slovlex-idsk-react-components';
import { Heading } from 'idsk-react-components';
import { useLocation } from 'react-router';
import usePravoEuDetail from '../../module/PravoEuDetail/hook/usePravoEuDetail';
import { Layout } from '../index';
import routes from '../../routing/routes';
import './pravoEuEuDetailPage.scss';
import GlobalErrors from '../../module/GlobalErrors';
import PravoEuDetail from '../../module/PravoEuDetail';

const PravoEuDetailPage = (): ReactElement => {
  const {
    pravoEu,
    pravoEuStatus,
  } = usePravoEuDetail();
  const currentLocation = useLocation();

  useEffect(() => {
    if (!pravoEuStatus.loading) {
      setTitle(getTitle());
    }
  }, [pravoEuStatus.loading]);

  if (pravoEuStatus.responseCode > 399) {
    return (
      <Layout>
        <Breadcrumbs
          routeList={[
            homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
            {
              to: routes.pravoEu.list.to,
              heading: routes.pravoEu.list.name,
            }]}
        />
        <NotFoundPage />
      </Layout>
    );
  }

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.pravoEu.list.to,
          heading: routes.pravoEu.list.name,
        },
        {
          heading: `${pravoEu?.celex || ''}`,
          to: currentLocation.pathname,
        }]}
      />
      <GlobalErrors />
      <div className="pravo-eu-detail-page">
        <PageLoader loading={pravoEuStatus.loading}>
          <>
            {pravoEu && (
              <>
                <div className="back-button">
                  <BackButton buttonStyle="link" />
                </div>
                <Heading size="xl">{pravoEu.nazovPredpisu}</Heading>
                <PravoEuDetail pravoEuDetail={pravoEu} />
              </>
            )}
          </>
        </PageLoader>
      </div>
    </Layout>
  );
};

export default PravoEuDetailPage;
